/// <reference types="@types/google.maps" />
import './assets/main.css';
import * as Sentry from '@sentry/vue';
import { createPinia } from 'pinia';
// Configure  pinia persisted state
import piniaPluginPersistedstate from 'pinia-plugin-persistedstate';
import { createApp } from 'vue';
import ToastPlugin from 'vue-toast-notification';
import 'vue-toast-notification/dist/theme-default.css';
import App from './App.vue';
import router from './router';
import './styling/fonts.css';
import { GOOGLE_API_KEY } from '@/config';
import { setOptions as setGoogleApiOptions } from '@googlemaps/js-api-loader';
import { ENVIRONMENT } from './config';

setGoogleApiOptions({ key: GOOGLE_API_KEY });

const pinia = createPinia();
pinia.use(piniaPluginPersistedstate);

const app = createApp(App);

Sentry.init({
  app,
  dsn: 'https://9a7dd10fc948f901025b3c43d8c6ad2c@o4505475530358784.ingest.us.sentry.io/4507334050578432',
  integrations: [Sentry.browserTracingIntegration(), Sentry.replayIntegration(), Sentry.httpClientIntegration()],
  // Performance Monitoring
  tracesSampleRate: 0.05,
  // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
  tracePropagationTargets: ['localhost'],
  // Session Replay
  replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
  replaysOnErrorSampleRate: 0.5, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
  normalizeDepth: 4, // Default is 3, but it is not useful to see only 3 levels deep in our stores.
  environment: ENVIRONMENT,
  enabled: ENVIRONMENT === 'staging' || ENVIRONMENT === 'production',
  enableMetrics: true,
  ignoreErrors: [
    `Cannot read properties of undefined (reading 'validateInput')`, // An issue with the peach iframe - https://layup.sentry.io/issues/5533368741/
    "Can't find variable: gmo", // An issue with google search https://issuetracker.google.com/issues/396043331 - https://layup.sentry.io/issues/6283535559/
    `Cannot read properties of undefined (reading 'disableBrandDetection')`, // An issue with the peach iframe - https://layup.sentry.io/issues/5598464546/
    `undefined is not an object (evaluating 'de.iframeCommunications["cvv_"+n].validateInput')`, // An issue with the peach iframe - https://layup.sentry.io/issues/5638055416/
    `Cannot read properties of undefined (reading 'domInteractive')`, // I think this is sentry trying to access the private peach iframe https://github.com/getsentry/sentry-javascript/issues/10011 - https://layup.sentry.io/issues/5939487607/
    `undefined is not an object (evaluating 'de.iframeCommunications["number_"+r].disableBrandDetection')`, // An issue with the peach iframe - https://layup.sentry.io/issues/5652637559/
    'Java exception was raised during method invocation', // Looks like an issue in sentry https://github.com/getsentry/sentry-javascript/issues/15065 - https://layup.sentry.io/issues/6240139142/
    'Error invoking postMessage: Java object is gone', // https://github.com/facebook/react/issues/34053
    `undefined is not an object (evaluating 'window.webkit.messageHandlers')`, // An issue with Sentry in iOS Facebook browser - https://github.com/getsentry/sentry-javascript/issues/3040
  ],
});

app.use(pinia);
app.use(router);
app.use(ToastPlugin);

app.mount('#app');
